'use strict';

var langs = require('langs/data'),
    codes = {},
    index, size, lang;


// rework language data
for ( index = 0, size = langs.length; index < size; index++ ) {
    lang = langs[index];

    // link all tables with the same data
    codes[lang['1']] = codes[lang['2T']] = codes[lang['2B']] = [lang['1'], lang['2T'], lang['2B']];
}

// clear
langs = null;


// public
module.exports = codes;
